module.exports = __webpack_public_path__ + "static/media/refresh.a4d29865.svg";